import { render, staticRenderFns } from "./Departamentos.vue?vue&type=template&id=460a37b3&scoped=true&"
import script from "./Departamentos.vue?vue&type=script&lang=js&"
export * from "./Departamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a37b3",
  null
  
)

export default component.exports